import { Card, BackgroundImage, Box, Badge, Text, Group } from "@mantine/core";
import { IconStack } from "@tabler/icons-react";

export function BundleCard({ bundle, onClick, mah = 400 }) {
  const coverUri =
    bundle?.cover?.pixelImages?.find((img) => img.type === "Thumbnail")?.uri ??
    bundle?.cover?.pixelImages?.find((img) => img.type === "VideoPoster")?.uri ??
    bundle?.cover?.pixelImages?.[0]?.uri;

  return (
    <Card
      withBorder
      shadow="sm"
      radius="md"
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <Card.Section>
        <BackgroundImage
          src={coverUri ?? ""}
          radius="sm"
          style={{
            backgroundColor: coverUri ? undefined : "var(--mantine-color-dark-5)",
          }}
        >
          <Box
            mah={mah}
            style={{
              height: `${mah}px`,
              position: "relative",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Group
              justify="space-between"
              align="flex-start"
              p="xs"
              style={{ width: "100%" }}
            >
              <Badge
                leftSection={<IconStack size={12} />}
                variant="filled"
                color="dark"
                size="sm"
              >
                {bundle.childCount} {bundle.childCount === 1 ? "photo" : "photos"}
              </Badge>
            </Group>
            <Box
              p="xs"
              style={{
                background:
                  "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.75) 100%)",
              }}
            >
              <Text c="white" fw={600} size="sm" lineClamp={2}>
                {bundle.title}
              </Text>
            </Box>
          </Box>
        </BackgroundImage>
      </Card.Section>
    </Card>
  );
}
